export const adevintaSites = [
  {
    href: 'https://motos.coches.net/',
    content: 'motos.net'
  },
  {
    href: 'https://www.milanuncios.com',
    content: 'Milanuncios'
  }
]

export const LINKS = [
  {
    title: 'FOOTER.LINK.COCHES.TITLE_ABOUT',
    urls: [
      {
        text: 'FOOTER.LINK.COCHES.ABOUT_US',
        url: '/conocenos/'
      },
      {
        text: 'FOOTER.LINK.COCHES.TAGLINE',
        url: '/la-mejor-oferta-de-coches/'
      },
      {
        text: 'FOOTER.LINK.COCHES.DOWNLOAD_APPS',
        url: '/descarga-app/'
      },
      {text: 'FOOTER.LINK.COCHES.HELP', url: 'https://ayuda.coches.net/'},
      {
        text: 'FOOTER.LINK.COCHES.PRESS',
        url: '/blog-profesionales/categoria/notas-de-prensa/'
      },
      {
        text: 'FOOTER.LINK.COCHES.WORK_WITH_US',
        url: 'https://www.adevinta.es/careers'
      },
      {
        text: 'FOOTER.LINK.COCHES.SITEMAP',
        url: '/mapa-web.aspx'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.COCHES.TITLE_FIND',
    urls: [
      {
        text: 'FOOTER.LINK.COCHES.SECOND_HAND',
        url: '/segunda-mano/'
      },
      {text: 'FOOTER.LINK.COCHES.KM0', url: '/km-0/'},
      {
        text: 'FOOTER.LINK.COCHES.NEW',
        url: '/nuevo/km-0/'
      },
      {
        text: 'FOOTER.LINK.COCHES.RENTING',
        url: '/renting/'
      },
      {
        text: 'FOOTER.LINK.COCHES.VANS_AND_INDUSTRIAL',
        url: '/vehiculos-industriales/'
      },
      {
        text: 'FOOTER.LINK.COCHES.CLASSIC_AND_COMPETITION',
        url: '/clasicos-competicion/'
      },
      {
        text: 'FOOTER.LINK.COCHES.MOTORHOME_AND_TRAILERS',
        url: '/autocaravanas-y-remolques/'
      },
      {
        text: 'FOOTER.LINK.COCHES.WITHOUT_LICENSE',
        url: '/sin-carnet/'
      },
      {
        text: 'FOOTER.LINK.COCHES.DEALERS_LIST',
        url: '/concesionarios/'
      },
      {
        text: 'FOOTER.LINK.COCHES.INSURANCE',
        url: '/seguros'
      },
      {
        text: 'FOOTER.LINK.COCHES.FINANCING',
        url: '/financiacion/'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.COCHES.TITLE_SELL',
    urls: [
      {
        text: 'FOOTER.LINK.COCHES.SELL',
        url: '/vender-mi-coche'
      },
      {
        text: 'FOOTER.LINK.COCHES.SELL_TO_DEALER',
        url: '/vender-mi-coche-a-un-concesionario'
      },
      {
        text: 'FOOTER.LINK.COCHES.RATING',
        url: '/tasacion-de-coches/'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.COCHES.TITLE_PROS',
    urls: [
      {
        text: 'FOOTER.LINK.COCHES.SIGNIN',
        url: 'https://pro.coches.net/login.aspx'
      },
      {
        text: 'FOOTER.LINK.COCHES.ADVERTISE',
        url: 'https://profesional.coches.net/anunciate-como-profesional/'
      },
      {
        text: 'FOOTER.LINK.COCHES.HELP_FOR_PROS',
        url: 'https://ayudaprofesionales.coches.net/'
      },
      {
        text: 'FOOTER.LINK.COCHES.BLOG_FOR_PROS',
        url: '/blog-profesionales/'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.COCHES.TITLE_GUIDES',
    urls: [
      {
        text: 'FOOTER.LINK.COCHES.WHAT_TO_BUY',
        url: '/que-coche-me-compro/'
      },
      {
        text: 'FOOTER.LINK.COCHES.SELL_AND_BUY_PROCEDURES',
        url: '/tramites-compra-venta-coches/'
      },
      {text: 'FOOTER.LINK.COCHES.FAQ', url: 'https://ayuda.coches.net/'},
      {
        text: 'FOOTER.LINK.COCHES.SECURITY_GUIDE',
        url: '/guia-seguridad-compra-venta-coches/'
      },
      {
        text: 'FOOTER.LINK.COCHES.TECH_INFO_AND_PRICES',
        url: '/fichas_tecnicas/'
      },
      {
        text: 'FOOTER.LINK.COCHES.TECH_INFO_FINDER',
        url: '/fichas_tecnicas/buscador/'
      },
      {
        text: 'FOOTER.LINK.COCHES.COMPARATOR',
        url: '/fichas_tecnicas/comparador/'
      },
      {
        text: 'FOOTER.LINK.COCHES.BRAND_AND_MODEL_FINDER',
        url: '/s/'
      },
      {
        text: 'FOOTER.LINK.COCHES.NEWS',
        url: '/noticias/'
      }
    ]
  }
]

export const POLICIES_LINKS = [
  {title: 'FOOTER.LINK.COCHES.CONDITIONS', url: '/condiciones-de-uso/'},
  {
    title: 'FOOTER.LINK.COCHES.COOKIES_POLICY',
    url: '/condiciones-de-uso/#cookies'
  },
  {
    title: 'FOOTER.LINK.COCHES.PRIVACY_POLICY',
    url: '/condiciones-de-uso/#privacidad'
  },
  {
    title: 'FOOTER.LINK.MOTOS.TRANSPARENCY',
    url: '/transparencia/'
  }
]
